import type { Transition } from "framer-motion"
import { lerp } from "./math"

export const transitions: { smoothEaseOut: Transition } = {
	smoothEaseOut: {
		type: "spring" as const,
		stiffness: 250,
		damping: 30,
		mass: 1,
	},
}

export interface Animation {
	update: (passthrough: number[]) => void
	cancel: () => void
}

export const createAnimation = (
	from: number[],
	to: number[],
	callback: (lastValues: number[], lastPassthrough: number[]) => void,
	duration: number = 150,
): Animation => {
	let frame: number | null = null
	let isCancelled = false

	let lastValues = from.slice()
	let lastPassthrough: number[] = []

	const startedAt = performance.now()

	const update = (passthrough: number[]) => {
		lastPassthrough = passthrough
		callback(lastValues, lastPassthrough)
	}

	const cancel = () => {
		isCancelled = true

		if (frame) {
			cancelAnimationFrame(frame)
		}
	}

	const animate = (time: number) => {
		const t = (time - startedAt) / duration

		lastValues = lastValues.map((_, index) => lerp(from[index] ?? 0, to[index] ?? 1, t))

		if (t <= 1 && !isCancelled) {
			update(lastPassthrough)
			frame = requestAnimationFrame(animate)
		} else {
			lastValues = to.slice()
			frame = null
		}
	}

	animate(performance.now())

	return {
		update,
		cancel,
	}
}
